import { render, staticRenderFns } from "./report-tag.vue?vue&type=template&id=c6862968&scoped=true"
import script from "./report-tag.vue?vue&type=script&lang=js"
export * from "./report-tag.vue?vue&type=script&lang=js"
import style0 from "./report-tag.vue?vue&type=style&index=0&id=c6862968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6862968",
  null
  
)

export default component.exports